const getCollaborationValue = (collaborationPercentage = 0) => {
  return (
    <div className="flex flex-col">
      <div className="text-black">{`${100 - collaborationPercentage} % Einzelarbeit`}</div>
      <div className="text-black">{`${collaborationPercentage} % Kommunikation`}</div>
    </div>
  )
}

export default getCollaborationValue
